if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"subPackages","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4(076|548|647)|5118|5331|7501|8497)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}